import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import bgImage from "./assets/bg1.png";

const Qualification = ({ userId }) => {
  const schema = yup.object().shape({
    HigestQualification: yup
      .string()
      .required("Highest Qualification is required"),
    PostGradugationQualification_Marks: yup
      .number()
      .nullable() // Allows null values
      .transform(
        (value, originalValue) => (originalValue === "" ? null : value) // Treat empty strings as null
      )
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .min(0, "Marks cannot be less than 0")
      .max(100, "Marks cannot exceed 100%")
      .notRequired(), // Allows the field to be empty

    HQualification_Marks: yup
      .number()
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .required("Marks are required")
      .min(0, "Marks cannot be less than 0")
      .max(100, "Marks cannot exceed 100%"),
    MQualification_Marks: yup
      .number()
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .required("Marks are required")
      .min(0, "Marks cannot be less than 0")
      .max(100, "Marks cannot exceed 100%"),
    LQualification_Marks: yup
      .number()
      .typeError("Only numbers are allowed") // Error for non-numeric input
      .integer("Only whole numbers are allowed") // Error for non-integer values (decimals)
      .required("Marks are required")
      .min(0, "Marks cannot be less than 0")
      .max(100, "Marks cannot exceed 100%"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (formData) => {
    try {
      const finalObj = { ...formData, userId };
      const token = localStorage.getItem("token");

      if (!token) {
        toast.error("user unauthorized.");
        return;
      }

      const response = await fetch(
        "   http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/Qualification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(finalObj),
        }
      );

      if (response.ok) {
        toast.success(
          "Educational Qualification Details Submitted Successfully!",
          {
            position: "top-center",
            transition: Slide,
          }
        );
        reset();
        setTimeout(() => {
          navigate("/EnteryCandidatePortel/FamilyDetails");
        }); // 1 second delay
      } else {
        toast.error(response.statusText, {
          position: "top-center",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form. Please try again.");
    }
  };

  return (
    <div
      className="w-full flex items-center justify-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
      <div className="">.</div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl mx-auto bg-white p-8 shadow-lg rounded-lg"
      >
        <h1 className="w-full text-3xl font-serif font-bold text-center my-6 text-indigo-600 ">
          Educational Qualification
        </h1>
        <div className="border-b-2 border-indigo-400 mb-3 mx-3"></div>

        <div className="overflow-x-auto mt-3 rounded-lg">
          <table className="table-auto min-w-full divide-y divide-gray-200">
            <thead className="bg-white">
              <tr>
                {[
                  "Qualification",
                  "University/Institute",
                  "Year of Passing",
                  "Marks %",
                  "Specialization",
                ].map((header) => (
                  <th
                    key={header}
                    className="py-3 px-2 sm:px-4 text-left font-medium text-gray-700"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {/* 10th */}
              <tr>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="10th"
                    {...register("LowerQualification")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    {...register("LQualification_University")}
                    placeholder="Your answer"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Year of Passing"
                    {...register("LQualification_Year_Of_Passing")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Marks %"
                    {...register("LQualification_Marks")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                  {errors.LQualification_Marks && (
                    <p className="text-red-500 text-md italic">
                      {errors.LQualification_Marks.message}
                    </p>
                  )}
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Specialization"
                    {...register("LQualification_Specalization")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
              </tr>

              {/* 12th */}
              <tr>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="12th"
                    {...register("MiddleQualification")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    {...register("MQualification_University")}
                    placeholder="Your answer"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Year of Passing"
                    {...register("MQualification_Year_Of_Passing")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Marks %"
                    {...register("MQualification_Marks")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                  {errors.MQualification_Marks && (
                    <p className="text-red-500 text-md italic">
                      {errors.MQualification_Marks.message}
                    </p>
                  )}
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Specialization"
                    {...register("MQualification_Specalization")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
              </tr>

              {/* Graduation */}
              <tr>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Graduation"
                    {...register("HigestQualification")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    {...register("HQualification_University")}
                    placeholder="Your answer"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Year of Passing"
                    {...register("HQualification_Year_Of_Passing")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Marks %"
                    {...register("HQualification_Marks")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                  {errors.HQualification_Marks && (
                    <p className="text-red-500 text-md italic">
                      {errors.HQualification_Marks.message}
                    </p>
                  )}
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Specialization"
                    {...register("HQualification_Specalization")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
              </tr>

              {/* Post Graduation */}
              <tr>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Post Graduation"
                    {...register("PostGradugationQualification")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    {...register("PostGradugationQualification_University")}
                    placeholder="Your answer"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Year of Passing"
                    {...register(
                      "PostGradugationQualification_Year_Of_Passing"
                    )}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Marks %"
                    {...register("PostGradugationQualification_Marks")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                  {errors.PostGradugationQualification_Marks && (
                    <p className="text-red-500 text-md italic">
                      {errors.PostGradugationQualification_Marks.message}
                    </p>
                  )}
                </td>
                <td className="py-2 px-2 sm:px-4">
                  <input
                    type="text"
                    placeholder="Specialization"
                    {...register("PostGradugationQualification_Specalization")}
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flex justify-center mt-4">
          <button
            type="submit"
            className="px-5 py-2 text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-600 rounded-md transition duration-200"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Qualification;
